export const useFilterVideo = () => {
    const currentFilter__main = useState('currentFilter__main', () => '全部');
    const currentFilter__hastag = useState('currentFilter__hastag', () => '全部');
    const filteredVideos = useState('filteredVideos', () => []);
    const videoSection = useState('videoSection', () => 'all');

    return { currentFilter__main, currentFilter__hastag, filteredVideos, videoSection };
};